import groq from 'groq';

import { ASSET } from '../common';
import { PRODUCT_SLUG } from '../product';

export const REVIEWS_CAROUSEL = groq`
  showOverview,
  showRecommendationScore,
  backgroundImage {
    ${ASSET}
  },
  reviews[]-> {
    title,
    rating,
    verifiedBuyer,
    "firstName": customerName.firstName,
    "lastName": customerName.lastName,
    product-> {
      ${PRODUCT_SLUG},
      "packagingThumbnail": packagingThumbnail { ${ASSET} },
      "formatThumbnail": formatThumbnail { ${ASSET} }
    }
  }
`;

export const REVIEWS_CAROUSEL_BLOCK = groq`
  _type == 'reviewsCarousel' => @-> {
    ${REVIEWS_CAROUSEL}
  }
`;
